type PromotionWidgetType = 'campaign_popup' | 'top_banner' | 'gift_box';

const CMS_API_BASE_URL = '/api/cms';

// 仅供 Builder 调试模式触发请求；Website 负责渲染和解析 CMS 响应。
export async function requestActivePromotionWidgets({
  language = 'en',
  page,
  types = ['campaign_popup', 'top_banner', 'gift_box'],
}: {
  language?: string;
  page?: string;
  types?: PromotionWidgetType[];
} = {}): Promise<void> {
  const params = new URLSearchParams({ language, types: types.join(',') });
  if (page) {
    params.set('page', page);
  }

  const response = await fetch(`${CMS_API_BASE_URL}/landing-widgets/active?${params.toString()}`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`Request active promotion widgets failed: ${response.status}`);
  }
}
